import { Activity, Heart, Zap, User, Dumbbell, Flame } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
const serviceTiers = [{
  title: "Frauen nach der Schwangerschaft\xA0",
  description: "Schnelle, sanfte Rückbildung ohne eigenes Training",
  icon: Activity
}, {
  title: "Frauen in den Wechseljahren\xA0",
  description: "Wieder mehr Kontrolle und Sicherheit im Alltag",
  icon: Heart
}, {
  title: "Männer nach Prostata-OP\xA0",
  description: "Gezielte Stärkung bei Inkontinenz und Erektionsstörungen",
  icon: Zap
}, {
  title: "Menschen mit\xA0\nRückenschmerzen",
  description: "Stabilisierung der Wirbelsäule durch tiefe Muskelschichten",
  icon: User
}, {
  title: "Profi- oder\xA0\nHobby-Sportler",
  description: "Stärkung der Core-Muskulatur für mehr Stabilität und Leistung",
  icon: Dumbbell
}, {
  title: "Mobilität\xA0\nim Alter",
  description: "Sanftes Beckenbodentraining ohne körperliche Belastung",
  icon: Flame
}];
export default function OurServices() {
  return <section data-section-id="224828" id="related-solutions" className="text-foreground py-12 bg-muted">
      <div className="container mx-auto px-4 max-w-5xl !w-[1092px] md:px-6">
        <h2 className="font-bold tracking-tight mb-6 text-center !text-6xl !text-[rgba(90,179,205,1)] !w-[1020px]">Für wen ist EMP Chair Pro geeignet?</h2>
        <p className="text-center text-muted-foreground max-w-2xl mx-auto mb-12 text-lg font-light">EMP Chair Pro unterstützt alle Menschen, die unter einem geschwächten Beckenboden leiden oder gezielt vorbeugen möchten.</p>
        <div className="grid grid-cols-1 gap-4 !w-[1100px] md:grid-cols-3 md:gap-6">
          {serviceTiers.map((tier, i) => {
          const Icon = tier.icon;
          return <Card key={i} data-index={i} className="bg-card/40 backdrop-blur-md border-border/60 shadow-sm hover:border-primary/40 transition-colors duration-300 rounded-lg py-10">
                <CardHeader className="pb-6 flex flex-row items-center gap-6 space-y-0">
                  <div className="flex items-center justify-center size-14 rounded-md text-accent-foreground shrink-0 !bg-[rgba(229,243,251,1)]">
                    <Icon className="size-7" strokeWidth={1.5} />
                  </div>
                  <CardTitle className="font-default text-xl md:text-2xl tracking-tight text-primary">
                    {tier.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-muted-foreground leading-relaxed font-default !text-lg">
                    {tier.description}
                  </p>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}